// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fm_a bhb_hm","SortLabel__newFeature":"fm_b bhb_uc bhb_ur"};